export default "__VITE_ASSET__DgsDobdX__"